import { useSyncExternalStore } from 'react';

import {
	getTitleServerSnapshot,
	getTitleSnapshot,
	subscribeToTitle,
} from '@atlassian/conversation-assistant-utils/history-location-observer';

/**
 * Returns the current `document.title`, re-rendering the consuming component when
 * the title changes.
 *
 * The SPA shell updates `document.title` *after* the navigation that changes the
 * location, so a render-time `document.title` read lags one navigation behind.
 * Subscribing via the shared observer (which watches the `<title>` element with a
 * `MutationObserver`) keeps title-derived UI fresh.
 */
export const useDocumentTitle = (): string =>
	useSyncExternalStore(subscribeToTitle, getTitleSnapshot, getTitleServerSnapshot);
